var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selected_stage)?_c('div',{staticClass:"col-12 font-size-20"},[[(_vm.selected_stage.name)?_c('h3',[_vm._v(_vm._s(_vm.selected_stage.name))]):_vm._e(),_vm._v(" "),_vm._l((_vm.selected_stage.levels),function(level){return (_vm.selected_stage.levels && _vm.selected_stage.levels.length)?_c('level',{key:level.enumValue,attrs:{"selected_level":level}}):_vm._e()})]],2):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6224f83c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/dashboard/pages/races/view-race/stage/stage.html
// module id = null
// module chunks = 